import axios from "axios";

const DEFAULT_BASE_URL = import.meta.env.VITE_BASE_URL;
const PH_RECHARGE_BASE_URL = import.meta.env.VITE_PH_RECHARGE_BASE_URL;
const PH_UID_MIN = 50000000;

function shouldUsePhRechargeApi(uid) {
  const normalizedUid = Number.parseInt(`${uid ?? ""}`.replace(/[^\d]/g, ""), 10);
  return Number.isFinite(normalizedUid) && normalizedUid >= PH_UID_MIN;
}

// 创建axios的对象
const instance = axios.create({
  baseURL: DEFAULT_BASE_URL, //配置固定域名
  timeout: 30000,
});

// 请求拦截
// 所有的网络请求都会走这个方法,可以在请求添加自定义内容
instance.interceptors.request.use(
  function (config) {
    const rechargeUid = config.rechargeUid ?? config.data?.user_id ?? config.params?.user_id;
    config.baseURL = shouldUsePhRechargeApi(rechargeUid) && PH_RECHARGE_BASE_URL
      ? PH_RECHARGE_BASE_URL
      : DEFAULT_BASE_URL;
    config.headers["Content-Type"] = "application/json;charset=utf-8;";
    config.headers["df_platform"] = "web";
    // config.headers["token"] = localStorage.getItem("user_token") || "no-token";
    return config;
  },
  function (err) {
    return Promise.request(err);
  }
);

// 响应拦截
// 此处可以根据服务器返回的状态码做相应的数据
instance.interceptors.response.use(
  function (response) {
    const res = response;
    if (res.status == 200) {
      return Promise.resolve(res.data);
    }
    if (res.status === 500) {
      console.log("接口500");
      return Promise.reject("error");
    } else if (res.errno === 502) {
      console.log("服务器内部错误");
      return Promise.reject("error");
    }
  },
  function (err) {
    return Promise.reject(err);
  }
);

// 封装get和post请求
export function get(url, params) {
  return instance.get(url, { params });
}

export function post(url, data) {
  return instance.post(url, data);
}

export default instance;
